let addressToken = 'ovllevxMoXkixgUHUhacCtAPC5LGkK35kX4Q7OCxwh8=ht';
let addressId = '1707';
let emailToken = 'bgkhEAx4WP2IhIncT5QxQYvpx4l5cLcS5dEWU01rxpo=ht';
let emailId = '1741'
if (window.location.hostname === 'www.davidaustinroses.com') {
  addressToken = '7J2WikVi/0vl/+gtzwOFC74frryvth1jh6ngp2dGr50=da';
  addressId = '1751';
  emailToken = '6+UN55OxMZMCX/+HJKBwuSHxW9f+8SiPz0UjOnDGv1U=da';
  emailId = '1752';
}

var afdOptions = {
  pceUrl: 'https://apps.afd.co.uk/json',
  id: addressId,
  token: addressToken,
  country: {
    customCountryConverter: convertIso
  },
  lookup: {
    showForCountries: [''],
    parentClass: 'afd-form-control',
    postcodeIsLookup: false,
    pushUp: true,
    // hideEmpties: true,
    beforeHideResults: true,
    notEmptyShowResults: true,
    afterHideLookupButton: true,
    searchAgain: true,
    searchAgainButtonIdentifier: '.afd-search-again-button-lookup',
    manualInputButton: true,
    manualInputButtonIdentifier: '.afd-manual-input-button-lookup',
    manualInputSearchButtonIdentifier: '.afd-manual-input-search-button-lookup',
    postcodeFirst: false
  },
  typeahead: {
    hideForCountries: [''],
    parentClass: 'afd-form-control',
    pushUp: [
      'Property',
      'Street'
    ],
    // hideEmpties: true,
    beforeHideResults: true,
    notEmptyShowResults: true,
    afterHideTypeahead: true,
	searchAgain: true,
    searchAgainButtonIdentifier: '.afd-search-again-button-typeahead',
    manualInputButton: true,
    manualInputButtonIdentifier: '.afd-manual-input-button-typeahead',
    manualInputSearchButtonIdentifier: '.afd-manual-input-search-button-typeahead',
    containerOnlyContainsControl: true,
    postcodeFirst: false,
    regionMap: function(val){
      var states={AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',DE:'Delaware',FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',TN:'Tennessee',TX:'Texas',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming'};
      return typeof states[val.PostalCounty] !== 'undefined' ? states[val.PostalCounty] : '';
    }
  },
  email: {
    invalidEmailMessage: 'Please enter a valid email address',
    loadingSpinner: '.fsFieldCell, [data-cf-field-type="email"]'
  }
};

var afdEmailOptions = {
  id: emailId,
  token: emailToken
}

var isMac = navigator.platform.toUpperCase().indexOf('MAC')>=0;
isMac = false;

$(document).on('afd:countryChanged', function(e, country){

  $('.afd-search-again-button-typeahead').hide();
  $('.afd-search-again-button-lookup').hide();
  $('.afd-manual-input-search-button-typeahead').hide();
  $('.afd-manual-input-search-button-lookup').hide();
  $(document).trigger('afd:initFields');

});

$(document).ready(function(){


  $(document).on("afd:emailValidationUpdatedFocusOut", function(e, element){

    if($(element).data('email-is-regex-valid') && $(element).data('email-is-afd-valid')){
      $(element)
        .closest('.newsletter-callout, #newsletter-modal')
        .find('.error-for-email')
        .hide();
    } else {
      $(element)
        .closest('.newsletter-callout, #newsletter-modal')
        .find('.error-for-email')
        .show();
    }

  });

  $('[data-afd-control="email"]').on('focusout', function(){
    $(".error-for-email").hide();
  });

});

function convertIso(country){
  var countriesList = [{"name":"Afghanistan","iso":"AFG"},{"name":"Aland Islands","iso":"ALA"},{"name":"Albania","iso":"ALB"},{"name":"Algeria","iso":"DZA"},{"name":"American Samoa","iso":"ASM"},{"name":"Andorra","iso":"AND"},{"name":"Angola","iso":"AGO"},{"name":"Anguilla","iso":"AIA"},{"name":"Antarctica","iso":"ATA"},{"name":"Antigua and Barbuda","iso":"ATG"},{"name":"Argentina","iso":"ARG"},{"name":"Armenia","iso":"ARM"},{"name":"Aruba","iso":"ABW"},{"name":"Australia","iso":"AUS"},{"name":"Austria","iso":"AUT"},{"name":"Azerbaijan","iso":"AZE"},{"name":"Bahamas","iso":"BHS"},{"name":"Bahrain","iso":"BHR"},{"name":"Bangladesh","iso":"BGD"},{"name":"Barbados","iso":"BRB"},{"name":"Belarus","iso":"BLR"},{"name":"Belgium","iso":"BEL"},{"name":"Belize","iso":"BLZ"},{"name":"Benin","iso":"BEN"},{"name":"Bermuda","iso":"BMU"},{"name":"Bhutan","iso":"BTN"},{"name":"Bolivia, Plurinational State of","iso":"BOL"},{"name":"Bosnia and Herzegovina","iso":"BIH"},{"name":"Botswana","iso":"BWA"},{"name":"Brazil","iso":"BRA"},{"name":"British Indian Ocean Territory","iso":"IOT"},{"name":"Brunei Darussalam","iso":"BRN"},{"name":"Bulgaria","iso":"BGR"},{"name":"Burkina Faso","iso":"BFA"},{"name":"Burundi","iso":"BDI"},{"name":"Cambodia","iso":"KHM"},{"name":"Cameroon","iso":"CMR"},{"name":"Canada","iso":"CAN"},{"name":"Cape Verde","iso":"CPV"},{"name":"Cayman Islands","iso":"CYM"},{"name":"Central African Republic","iso":"CAF"},{"name":"Chad","iso":"TCD"},{"name":"Chile","iso":"CHL"},{"name":"China","iso":"CHN"},{"name":"Christmas Island","iso":"CXR"},{"name":"Cocos (Keeling) Islands","iso":"CCK"},{"name":"Colombia","iso":"COL"},{"name":"Comoros","iso":"COM"},{"name":"Congo","iso":"COG"},{"name":"Congo, The Democratic Republic of the","iso":"COD"},{"name":"Cook Islands","iso":"COK"},{"name":"Costa Rica","iso":"CRI"},{"name":"Cote d'Ivoire","iso":"CIV"},{"name":"Croatia","iso":"HRV"},{"name":"Cuba","iso":"CUB"},{"name":"Cyprus","iso":"CYP"},{"name":"Czech Republic","iso":"CZE"},{"name":"Denmark","iso":"DNK"},{"name":"Djibouti","iso":"DJI"},{"name":"Dominica","iso":"DMA"},{"name":"Dominican Republic","iso":"DOM"},{"name":"Ecuador","iso":"ECU"},{"name":"Egypt","iso":"EGY"},{"name":"El Salvador","iso":"SLV"},{"name":"Equatorial Guinea","iso":"GNQ"},{"name":"Eritrea","iso":"ERI"},{"name":"Estonia","iso":"EST"},{"name":"Ethiopia","iso":"ETH"},{"name":"Falkland Islands (Malvinas)","iso":"FLK"},{"name":"Faroe Islands","iso":"FRO"},{"name":"Fiji","iso":"FJI"},{"name":"Finland","iso":"FIN"},{"name":"France","iso":"FRA"},{"name":"French Guiana","iso":"GUF"},{"name":"French Polynesia","iso":"PYF"},{"name":"French Southern Territories","iso":"ATF"},{"name":"Gabon","iso":"GAB"},{"name":"Gambia","iso":"GMB"},{"name":"Georgia","iso":"GEO"},{"name":"Germany","iso":"DEU"},{"name":"Ghana","iso":"GHA"},{"name":"Gibraltar","iso":"GIB"},{"name":"Greece","iso":"GRC"},{"name":"Greenland","iso":"GRL"},{"name":"Grenada","iso":"GRD"},{"name":"Guadeloupe","iso":"GLP"},{"name":"Guatemala","iso":"GTM"},{"name":"Guernsey","iso":"GBR"},{"name":"Guinea","iso":"GIN"},{"name":"Guinea-bissau","iso":"GNB"},{"name":"Guyana","iso":"GUY"},{"name":"Haiti","iso":"HTI"},{"name":"Holy See (Vatican City State)","iso":"VAT"},{"name":"Honduras","iso":"HND"},{"name":"Hong Kong","iso":"HKG"},{"name":"Hungary","iso":"HUN"},{"name":"Iceland","iso":"ISL"},{"name":"India","iso":"IND"},{"name":"Indonesia","iso":"IDN"},{"name":"Iran, Islamic Republic of","iso":"IRN"},{"name":"Iraq","iso":"IRQ"},{"name":"Ireland","iso":"IRL"},{"name":"Isle Of Man","iso":"GBR"},{"name":"Israel","iso":"ISR"},{"name":"Italy","iso":"ITA"},{"name":"Jamaica","iso":"JAM"},{"name":"Japan","iso":"JPN"},{"name":"Jersey","iso":"GBR"},{"name":"Jordan","iso":"JOR"},{"name":"Kazakhstan","iso":"KAZ"},{"name":"Kenya","iso":"KEN"},{"name":"Kiribati","iso":"KIR"},{"name":"Korea, Democratic People's Republic of","iso":"PRK"},{"name":"Korea, Republic of","iso":"KOR"},{"name":"Kuwait","iso":"KWT"},{"name":"Kyrgyzstan","iso":"KGZ"},{"name":"Lao People's Democratic Republic","iso":"LAO"},{"name":"Latvia","iso":"LVA"},{"name":"Lebanon","iso":"LBN"},{"name":"Lesotho","iso":"LSO"},{"name":"Liberia","iso":"LBR"},{"name":"Libya","iso":"LBY"},{"name":"Liechtenstein","iso":"LIE"},{"name":"Lithuania","iso":"LTU"},{"name":"Luxembourg","iso":"LUX"},{"name":"Macao","iso":"MAC"},{"name":"Republic of Macedonia","iso":"MKD"},{"name":"Madagascar","iso":"MDG"},{"name":"Malawi","iso":"MWI"},{"name":"Malaysia","iso":"MYS"},{"name":"Maldives","iso":"MDV"},{"name":"Mali","iso":"MLI"},{"name":"Malta","iso":"MLT"},{"name":"Marshall Islands","iso":"MHL"},{"name":"Martinique","iso":"MTQ"},{"name":"Mauritania","iso":"MRT"},{"name":"Mauritius","iso":"MUS"},{"name":"Mayotte","iso":"MYT"},{"name":"Mexico","iso":"MEX"},{"name":"Micronesia, Federated States of","iso":"FSM"},{"name":"Moldova, Republic of","iso":"MDA"},{"name":"Monaco","iso":"MCO"},{"name":"Mongolia","iso":"MNG"},{"name":"Montenegro","iso":"MNE"},{"name":"Montserrat","iso":"MSR"},{"name":"Morocco","iso":"MAR"},{"name":"Mozambique","iso":"MOZ"},{"name":"Myanmar","iso":"MMR"},{"name":"Namibia","iso":"NAM"},{"name":"Nauru","iso":"NRU"},{"name":"Nepal","iso":"NPL"},{"name":"Netherlands","iso":"NLD"},{"name":"Netherlands Antilles","iso":"ANT"},{"name":"New Caledonia","iso":"NCL"},{"name":"New Zealand","iso":"NZL"},{"name":"Nicaragua","iso":"NIC"},{"name":"Niger","iso":"NER"},{"name":"Nigeria","iso":"NGA"},{"name":"Niue","iso":"NIU"},{"name":"Norfolk Island","iso":"NFK"},{"name":"Northern Mariana Islands","iso":"MNP"},{"name":"Norway","iso":"NOR"},{"name":"Oman","iso":"OMN"},{"name":"Pakistan","iso":"PAK"},{"name":"Palau","iso":"PLW"},{"name":"Palestinian Territory","iso":"PSE"},{"name":"Panama","iso":"PAN"},{"name":"Papua New Guinea","iso":"PNG"},{"name":"Paraguay","iso":"PRY"},{"name":"Peru","iso":"PER"},{"name":"Philippines","iso":"PHL"},{"name":"Pitcairn","iso":"PCN"},{"name":"Poland","iso":"POL"},{"name":"Portugal","iso":"PRT"},{"name":"Puerto Rico","iso":"PRI"},{"name":"Qatar","iso":"QAT"},{"name":"Reunion","iso":"REU"},{"name":"Romania","iso":"ROU"},{"name":"Russian Federation","iso":"RUS"},{"name":"Russia","iso":"RUS"},{"name":"Rwanda","iso":"RWA"},{"name":"Saint Barthelemy","iso":"BLM"},{"name":"Saint Helena","iso":"SHN"},{"name":"Saint Kitts and Nevis","iso":"KNA"},{"name":"Saint Lucia","iso":"LCA"},{"name":"Saint Martin","iso":"SXM"},{"name":"Saint Pierre and Miquelon","iso":"SPM"},{"name":"Saint Vincent and the Grenadines","iso":"VCT"},{"name":"Samoa","iso":"WSM"},{"name":"San Marino","iso":"SMR"},{"name":"Sao Tome and Principe","iso":"STP"},{"name":"Saudi Arabia","iso":"SAU"},{"name":"Senegal","iso":"SEN"},{"name":"Serbia","iso":"SRB"},{"name":"Seychelles","iso":"SYC"},{"name":"Sierra Leone","iso":"SLE"},{"name":"Singapore","iso":"SGP"},{"name":"Slovakia","iso":"SVK"},{"name":"Slovenia","iso":"SVN"},{"name":"Solomon Islands","iso":"SLB"},{"name":"Somalia","iso":"SOM"},{"name":"South Africa","iso":"ZAF"},{"name":"South Georgia and the South Sandwich Islands","iso":"SGS"},{"name":"Spain","iso":"ESP"},{"name":"Sri Lanka","iso":"LKA"},{"name":"Sudan","iso":"SDN"},{"name":"Suriname","iso":"SUR"},{"name":"Svalbard and Jan Mayen","iso":"SJM"},{"name":"Swaziland","iso":"SWZ"},{"name":"Sweden","iso":"SWE"},{"name":"Switzerland","iso":"CHE"},{"name":"Syrian Arab Republic","iso":"SYR"},{"name":"Taiwan, Republic of China","iso":"TWN"},{"name":"Tajikistan","iso":"TJK"},{"name":"Tanzania, United Republic of","iso":"TZA"},{"name":"Thailand","iso":"THA"},{"name":"Timor-leste","iso":"TLP"},{"name":"Togo","iso":"TGO"},{"name":"Tokelau","iso":"TKL"},{"name":"Tonga","iso":"TON"},{"name":"Trinidad and Tobago","iso":"TTO"},{"name":"Tunisia","iso":"TUN"},{"name":"Turkey","iso":"TUR"},{"name":"Turkmenistan","iso":"TKM"},{"name":"Turks and Caicos Islands","iso":"TCA"},{"name":"Tuvalu","iso":"TUV"},{"name":"Uganda","iso":"UGA"},{"name":"Ukraine","iso":"UKR"},{"name":"United Arab Emirates","iso":"ARE"},{"name":"United Kingdom","iso":"GBR"},{"name":"United States","iso":"USA"},{"name":"United States Minor Outlying Islands","iso":"UMI"},{"name":"Uruguay","iso":"URY"},{"name":"Uzbekistan","iso":"UZB"},{"name":"Vanuatu","iso":"VUT"},{"name":"Venezuela","iso":"VEN"},{"name":"Vietnam","iso":"VNM"},{"name":"Virgin Islands, British","iso":"VGB"},{"name":"Wallis and Futuna","iso":"WLF"},{"name":"Western Sahara","iso":"ESH"},{"name":"Yemen","iso":"YEM"},{"name":"Zambia","iso":"ZMB"},{"name":"Zimbabwe","iso":"ZWE"}];
  for(var i = 0; i < countriesList.length; i++) {
    if(countriesList[i].name === country){
		return countriesList[i].iso;
    }
  }
  console.warn('unable to convert country - ' + country);
}

$(document).ready(function(){

  $('.newsletter-callout__form input[type="submit"]').click(function(e){
    if(!$('.newsletter-callout__form [data-afd-control="email"]').get()[0].validity.valid){
      e.preventDefault();
    }
  });


  if(isMac) {

    $('[data-afd-control="lookupResultsList"]').attr({multiple: false, size: null});

  }


  $(document).on('afd:postRenderInitComplete', function(e){


    if(isMac) {

      $('[data-afd-control="lookupResultsList"]').attr({multiple: false, size: null});

    }

  });

  $(document).on('afd:lookupComplete', function(e, results) {

    // if zero results add error class
    if(results.length === 0) {
      $('[data-address-field="zip"], #AddressZipNew, [data-afd-result="Postcode"]').addClass('afd-result-error');
    } else {
      $('[data-address-field="zip"], #AddressZipNew, [data-afd-result="Postcode"]').removeClass('afd-result-error');
    }

    if(isMac) {

      $('[data-afd-control="lookupResultsList"]').attr({multiple: false, size: null});

    }

  });


  $('[type="submit"]').on('click', function(e){

    if($(this).siblings('[data-afd-control="email"]').length > 0 && !$(this).siblings('[data-afd-control="email"]').data("email-is-afd-valid")) {
    	e.preventDefault();
    };


  });




});

